import { ADMIN_URL_PREFIX } from '../constants';

/**
 * Check whether a URL points to the back office.
 * @param url - URL to check.
 * @returns true when the URL holds the admin prefix.
 */
export const isAdminUrl = (url: string) => url.indexOf(`/${ADMIN_URL_PREFIX}/`) >= 0;
